module.exports = __webpack_public_path__ + "img/icon-history-inactive.301fe838.svg";